const OrnamentalDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center py-4 ${className}`}>
    <svg
      viewBox="0 0 600 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full max-w-md h-8 text-primary/25"
      aria-hidden="true"
    >
      {/* Left line */}
      <line x1="0" y1="20" x2="240" y2="20" stroke="currentColor" strokeWidth="1" />

      {/* Left small dots */}
      <circle cx="245" cy="20" r="2" fill="currentColor" />
      <circle cx="255" cy="20" r="2" fill="currentColor" />

      {/* Center lotus */}
      <g transform="translate(300, 20)">
        {/* Petals */}
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(45)" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(90)" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(135)" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(180)" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(225)" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(270)" />
        <ellipse cx="0" cy="-8" rx="4" ry="8" fill="currentColor" opacity="0.6" transform="rotate(315)" />
        {/* Center */}
        <circle cx="0" cy="0" r="3" fill="currentColor" />
      </g>

      {/* Right small dots */}
      <circle cx="345" cy="20" r="2" fill="currentColor" />
      <circle cx="355" cy="20" r="2" fill="currentColor" />

      {/* Right line */}
      <line x1="360" y1="20" x2="600" y2="20" stroke="currentColor" strokeWidth="1" />
    </svg>
  </div>
);

export default OrnamentalDivider;
